import styled from "styled-components";

export const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;
